export const getUserAllDetails = `query getUser{
    getUser{
        uid
        kommpId
        brokers{
            name
            email
            phone
            img
        }
        name
        accounts{
            type
            number
        }
        need_transaction_second_confirmation
        phone
        tax_number
        email
        mailing_address{
            country
            city
            zip_code
            address
        }
        billing_address{
            country
            city
            zip_code
            address
        }
        place_of_birth
        time_of_birth
        mothers_name
        personal_documents{
            type
            type_en
            number
            expiry
        }
        is_company
        registration_number
        company_name
        terms_and_conditions{
            id
            time
            name
            name_en
            attachment
            attachment_en
        }
        personal_contracts{
            id
            time
            name
            name_en
            attachment
            attachment_en
        }
    }
}`;
